import { joinPaths, createURLDescriptor } from './URLTools';
import { NotFoundError } from './Errors';
export function createChunk(type, request, details, ensureTrailingSlash) {
    if (ensureTrailingSlash === void 0) { ensureTrailingSlash = true; }
    return Object.assign({
        type: type,
        url: createURLDescriptor({
            pathname: request.mountpath,
            query: request.query,
        }, { ensureTrailingSlash: ensureTrailingSlash }),
    }, details);
}
export function createNotFoundChunk(request) {
    var fullPathname = joinPaths(request.mountpath, request.path);
    return {
        type: 'error',
        url: createURLDescriptor({
            pathname: fullPathname,
            query: request.query,
        }),
        error: new NotFoundError(fullPathname),
    };
}
//# sourceMappingURL=Chunks.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/navi/dist/es/Chunks.js
// module id = 7
// module chunks = 0